import type { NextPage } from 'next';
import { PrivacyDisclaimerComponent, getStaticPropsNicho } from 'ui';

const PrivacyDisclaimer: NextPage = () => {
	return <PrivacyDisclaimerComponent domain="www.copitosdenieve.com" />;
};

export const getStaticProps = getStaticPropsNicho();
export default PrivacyDisclaimer;
